export const actionsButtonsStyles = {
    marginRight: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    width: "30px",
    my: { xs: 1, sm: 1, md: 0 },
    height: "35px",
};

export const searchBoxStyle = {
    display: "flex",
    my: 1,
    flexGrow: 1,
    flexDirection: {
        xs: "column",
        sm: "column",
        md: "row",
    },
    justifyContent: { xs: "flex-start" },
    width: { xs: "100%", sm: "100%", md: "100%" },
};

export const searchBoxTextStyle = {
    width: {
        xs: "100%",
        sm: "100%",
        md: "34.5%",
    },
    paddingRight: { xs: 0, sm: 0, md: 0.2 },
};

export const resetButtonStyle = {
    marginRight: 1,
    height: "35px",
    "&:hover": {
        color: "#ff4d4f",
        borderColor: "#ff4d4f",
    },
    my: { xs: 1, sm: 1, md: 0 },
    width: { xs: "95%", sm: "8%", md: "8%" },
};

export const searchButtonStyle = {
    mx: 0,
    height: "35px",
    my: { xs: 1, sm: 1, md: 0 },
    width: { xs: "95%", sm: "95%", md: "12%" },
};

export const reachResetButtonDivStyles = {
    display: "flex",
    mb: {
        xs: 1,
        sm: 3,
        md: 3,
    },
    flexGrow: 1,
    flexDirection: "row",
    justifyContent: { xs: "flex-end" },
    width: {
        xs: "100%",
        sm: "100%",
        md: "100%",
    },
};

export const exportCopyDivStyles = {
    display: "flex",
    my: 1,
    flexGrow: 1,
    flexDirection: {
        xs: "row",
        sm: "row",
        md: "row",
    },
    justifyContent: { xs: "flex-start" },
    width: {
        xs: "100%",
        sm: "100%",
        md: "100%",
    },
    paddingRight: "0px",
};
